import { setCookieDays, setCookieSeconds } from '../../../utils/cookies';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const login = createAsyncThunk('auth/login', async ({ email, password }, thunkAPI) => {
  try {
    const res = await axiosInstance.post(`/authorization`, {
      email,
      password,
      scope: 'backoffice',
    });

    const data = await res.data;

    setCookieDays('grbut', data?.access_token, 1);
    setCookieDays('grbrt', data?.refresh_token, 1);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const logout = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
  try {
    await axiosInstance.get(`/authorization/destroy`);
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  } finally {
    setCookieSeconds('grbut', '', 1);
    setCookieSeconds('grbrt', '', 1);
  }
});

export const refreshToken = createAsyncThunk('auth/refresh-token', async (_, thunkAPI) => {
  const authData = thunkAPI.getState().auth.data;
  if (!authData?.refresh_token) {
    return thunkAPI.rejectWithValue({ message: 'No refresh token available' });
  }
  const refreshToken = authData.refresh_token;

  try {
    const res = await axiosInstance.post(`/authorization/refresh`, {
      refresh_token: refreshToken,
    });

    const data = await res.data;

    setCookieDays('grbut', data?.access_token, 1);
    setCookieDays('grbrt', data?.refresh_token, 1);

    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
